"use strict";
/*!
 * Buttplug JS Source Code File - Visit https://buttplug.io for more info about
 * the project. Licensed under the BSD 3-Clause license. See LICENSE file in the
 * project root for full license information.
 *
 * @copyright Copyright (c) Nonpolynomial Labs LLC. All rights reserved.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtplugMessageSorter = void 0;
const Messages = __importStar(require("../core/Messages"));
const Exceptions_1 = require("../core/Exceptions");
class ButtplugMessageSorter {
    constructor(_useCounter) {
        this._useCounter = _useCounter;
        this._counter = 1;
        this._waitingMsgs = new Map();
    }
    // One of the places we should actually return a promise, as we need to store
    // them while waiting for them to return across the line.
    // tslint:disable:promise-function-async
    PrepareOutgoingMessage(aMsg) {
        if (this._useCounter) {
            aMsg.Id = this._counter;
            // Always increment last, otherwise we might lose sync
            this._counter += 1;
        }
        let res;
        let rej;
        const msgPromise = new Promise((resolve, reject) => { res = resolve; rej = reject; });
        this._waitingMsgs.set(aMsg.Id, [res, rej]);
        return msgPromise;
    }
    ParseIncomingMessages(aMsgs) {
        const noMatch = [];
        for (const x of aMsgs) {
            if (x.Id !== Messages.SYSTEM_MESSAGE_ID && this._waitingMsgs.has(x.Id)) {
                const [res, rej] = this._waitingMsgs.get(x.Id);
                // If we've gotten back an error, reject the related promise using a
                // ButtplugException derived type.
                if (x.Type === Messages.Error) {
                    rej(Exceptions_1.ButtplugException.FromError(x));
                    continue;
                }
                res(x);
                continue;
            }
            else {
                noMatch.push(x);
            }
        }
        return noMatch;
    }
}
exports.ButtplugMessageSorter = ButtplugMessageSorter;
//# sourceMappingURL=ButtplugMessageSorter.js.map